import React from 'react';
import styled from 'styled-components';
const DocsPageOrderedList = ({ ...rest }) => {
    return React.createElement(DocsPageOrderedListWrapper, { ...rest });
};
export default DocsPageOrderedList;
const DocsPageOrderedListWrapper = styled.ol `
`;
//# sourceMappingURL=DocsPageOrderedList.js.map